import React from 'react';

export function ProductCardSkeleton() {
  return (
    <div className="animate-pulse">
      <div className="aspect-[3/4] skeleton-shimmer mb-4" />
      <div className="h-3 skeleton-shimmer w-1/3 mb-2" />
      <div className="h-5 skeleton-shimmer w-3/4 mb-3" />
      <div className="h-4 skeleton-shimmer w-1/4" />
    </div>
  );
}

export function ProductGridSkeleton({ count = 8 }) {
  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
      {Array(count).fill(0).map((_, i) => <ProductCardSkeleton key={i} />)}
    </div>
  );
}

export function OrderRowSkeleton() {
  return (
    <div className="animate-pulse border-b border-green-800/20 py-5">
      <div className="flex justify-between">
        <div className="flex gap-4">
          <div className="w-12 h-16 skeleton-shimmer" />
          <div>
            <div className="h-4 skeleton-shimmer w-32 mb-2" />
            <div className="h-3 skeleton-shimmer w-24" />
          </div>
        </div>
        <div className="h-6 skeleton-shimmer w-20" />
      </div>
    </div>
  );
}

export function StatCardSkeleton() {
  return (
    <div className="animate-pulse border border-green-800/40 p-6">
      <div className="h-3 skeleton-shimmer w-1/3 mb-4" />
      <div className="h-8 skeleton-shimmer w-1/2 mb-2" />
      <div className="h-3 skeleton-shimmer w-2/3" />
    </div>
  );
}

export function PageLoader() {
  return (
    <div className="min-h-screen bg-green-950 flex items-center justify-center">
      <div className="flex flex-col items-center gap-5">
        <div className="relative w-12 h-12">
          <div className="absolute inset-0 border-2 border-gold-500/20 rounded-full" />
          <div className="absolute inset-0 border-2 border-transparent border-t-gold-500 rounded-full animate-spin" />
        </div>
        <p className="text-cream/30 text-[10px] tracking-[0.4em] uppercase font-body">Loading</p>
      </div>
    </div>
  );
}

export function InlineLoader({ size = 'sm' }) {
  const s = size === 'sm' ? 'w-4 h-4' : 'w-6 h-6';
  return (
    <div className={`${s} border-2 border-current border-t-transparent rounded-full animate-spin`} />
  );
}
